import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from './navbar';
import { useDispatch, useSelector } from "react-redux";
import { register } from '../store/Slices/authSlice';
import toast, { Toaster } from "react-hot-toast";
import LoadingScreen from '../skeletons/loadingSkeleton';
import { encryptData } from '../helpers/encryptData';

const AdminPage = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [orangeContractID, setOrangeContractID] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.auth.loading);
    const location = useLocation();
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL

    useEffect(() => {
        if (sessionStorage.email !== adminEmail) {
            navigate('/');
        }
    }, [location, navigate]);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);

    };

    const handleEmailBlur = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email) && email.length > 0) {
            setError('Invalid email format');
        } else {
            setError('');
        }
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);

        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]{8,}$/;
        if (!passwordRegex.test(e.target.value)) {
            setError('Password must be at least 8 characters long, contain at least one capital letter and one alphanumeric character');
            return;
        }
        if (confirmPassword !== e.target.value) {
            setError('Passwords do not match');
        }
        else {
            setError('');
        }
    };

    const handleFirstNameChange = (e) => {
        setFirstName(e.target.value);
    };

    const handleLastNameChange = (e) => {
        setLastName(e.target.value);
    };

    const handleCompanyNameChange = (e) => {
        setCompanyName(e.target.value);
    };

    const handleOrangeContractIDChange = (e) => {
        // if (isNaN(e.target.value)) {
        //     setError('Orange Contract ID must be a number');
        //     return;
        // }
        // else{
        //     setError("");
        // }
        setOrangeContractID(e.target.value);
    };

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (password !== e.target.value) {
            setError('Passwords do not match');
        }
        else {
            setError('');
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!email || !password || !firstName || !lastName || !companyName || !orangeContractID) {
            setError('All fields are mandatory');
            toast.error('All fields are mandatory');
            return;
        }

        const encryptedEmail = encryptData(email, localStorage.getItem("publicKey"));
        const encryptedPassword = encryptData(password, localStorage.getItem("publicKey"));
        const encryptedOrangeContractID = encryptData(orangeContractID, localStorage.getItem("publicKey"));
        const encryptedCompanyName = encryptData(companyName, localStorage.getItem("publicKey"));
        const encryptedFirstName = encryptData(firstName, localStorage.getItem("publicKey"));
        const encryptedLastName = encryptData(lastName, localStorage.getItem("publicKey"));

        const adminData = { encryptedCompanyName, encryptedEmail, encryptedPassword, encryptedOrangeContractID, encryptedFirstName, encryptedLastName };
        dispatch(register(adminData)).then((response) => {
            if (response?.payload?.message === "success") {
                navigate("/admin", { state: { email: email, admin: true } });
                toast.success("User Created Successfully");
                setEmail('');
                setPassword('');
                setFirstName('');
                setLastName('');
                setCompanyName('');
                setOrangeContractID('');
                return;
            }
            else {
                setError(response?.error?.message || 'Invalid email or password');
            }
        });
    };

    return (
        <div>
            <Toaster position="top-center" reverseOrder={false}></Toaster>
            <Header />
            {loading ? <LoadingScreen /> :
                <div style={{ paddingTop: "20px" }} >
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h1 style={{ paddingLeft: '10px', color: '#f16e00', fontWeight: 'bold' }}>Create New User</h1>
                    </div >
                    <br></br>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <form onSubmit={handleSubmit} className="login-box" style={{ width: '40%' }} >
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div>
                                        <label>Email:</label>
                                        <input
                                            type="email"
                                            value={email}
                                            className="form-control rounded"
                                            onChange={handleEmailChange}
                                            onBlur={handleEmailBlur}
                                        />
                                    </div>
                                    <div>
                                        <label>First Name:</label>
                                        <input
                                            type="text"
                                            value={firstName}
                                            className="form-control rounded"
                                            onChange={handleFirstNameChange}
                                        />
                                    </div>
                                    <div>
                                        <label>Last Name:</label>
                                        <input
                                            type="text"
                                            value={lastName}
                                            className="form-control rounded"
                                            onChange={handleLastNameChange}
                                        />
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div>
                                        <label>Password:</label>
                                        <input
                                            type="password"
                                            value={password}
                                            className="form-control rounded"
                                            onChange={handlePasswordChange}
                                        />
                                    </div>
                                    <div>
                                        <label>Confirm Password:</label>
                                        <input
                                            type="password"
                                            className="form-control rounded"
                                            onChange={handleConfirmPasswordChange}
                                        />
                                    </div>
                                    <div>
                                        <label>Company Name:</label>
                                        <input
                                            type="text"
                                            value={companyName}
                                            className="form-control rounded"
                                            onChange={handleCompanyNameChange}
                                        />
                                    </div>
                                    <div>
                                        <label>ICO01:</label>
                                        <input
                                            type="text"
                                            value={orangeContractID}
                                            className="form-control rounded"
                                            onChange={handleOrangeContractIDChange}
                                        />
                                    </div>
                                </div>
                                {error && <span style={{ color: 'red' }}>{error}</span>}
                                <button type="submit" disabled={!!error}>Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            }
        </div>
    );
};

export default AdminPage;